"use client";

import { setConfig } from "@/store/configSlice";
import type { AppConfig } from "@/store/configSlice";
import store from "@/store/store";
import { useRef } from "react";
import { Provider } from "react-redux";

export default function StoreProvider({ children, initialConfig }: StoreProviderProps) {
  const configured = useRef(false);
  if (!configured.current && initialConfig) {
    store.dispatch(setConfig(initialConfig));
    configured.current = true;
  }
  return <Provider store={store}>{children}</Provider>;
}

type StoreProviderProps = {
  children: React.ReactNode;
  initialConfig?: Partial<AppConfig>;
};
